export const dedupeArray = <T>(arr: T[]): T[] => {
    return [...new Set(arr)]
}

export const sortByPredefinedOrder = <T>(
    items: T[],
    order: unknown[],
    getKey: (item: T) => unknown
): T[] => {
    return [...items].sort((a, b) => {
        const aIndex = order.indexOf(getKey(a))
        const bIndex = order.indexOf(getKey(b))

        if (aIndex === -1 && bIndex === -1) return 0
        if (aIndex === -1) return 1
        if (bIndex === -1) return -1
        
        return aIndex - bIndex
    })
}